(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nb-review-carousel')) {
  customElements.define('nb-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nb-rv__track');
      if (!this.track) return;
      this.cards = [...this.track.children];
      this.control = this.querySelector('[data-play]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('[data-total]').textContent = this.cards.length;
      this.querySelector('[data-previous]').addEventListener('click', () => { this.pause(); this.go(-1); }, options);
      this.querySelector('[data-next]').addEventListener('click', () => { this.pause(); this.go(1); }, options);
      this.control.addEventListener('click', () => { this.playing = !this.playing; this.update(); }, options);
      this.track.addEventListener('scroll', () => { this.querySelector('[data-position]').textContent = this.index() + 1; }, { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.pause(); this.go(event.key === 'ArrowRight' ? 1 : -1); } }, options);
      this.track.addEventListener('pointerdown', () => this.pause(), options);
      this.addEventListener('mouseenter', () => { this.hovering = true; this.update(); }, options);
      this.addEventListener('mouseleave', () => { this.hovering = false; this.update(); }, options);
      this.track.addEventListener('focusin', () => this.pause(), options);
      document.addEventListener('visibilitychange', () => this.update(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, options);
      this.resize = new ResizeObserver(() => this.update()); this.resize.observe(this.track);
      this.intersection = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.update(); }); this.intersection.observe(this);
      this.update();
    }
    index() { let value = 0; let distance = Infinity; for (let i = 0; i < this.cards.length; i++) { const d = Math.abs(this.cards[i].offsetLeft - this.track.offsetLeft - this.track.scrollLeft); if (d < distance) { distance = d; value = i; } } return value; }
    go(direction) { const max = this.track.scrollWidth - this.track.clientWidth; let next = this.index() + direction; if (direction > 0 && this.track.scrollLeft >= max - 3) next = 0; if (next < 0) next = this.cards.length - 1; next %= this.cards.length; this.track.scrollTo({left: this.cards[next].offsetLeft - this.track.offsetLeft, behavior: this.motion.matches ? 'instant' : 'smooth'}); }
    pause() { this.playing = false; this.update(); }
    update() { clearInterval(this.timer); const overflow = this.track.scrollWidth > this.track.clientWidth + 2; this.querySelector('.nb-rv__controls').hidden = !overflow; this.control.setAttribute('aria-label', this.playing ? this.control.dataset.pauseLabel : this.control.dataset.playLabel); this.control.firstElementChild.textContent = this.playing ? 'Ⅱ' : '▶'; if (overflow && this.playing && this.inView && !this.hovering && !document.hidden) this.timer = setInterval(() => this.go(1), Number(this.dataset.interval) || 6000); }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); this.resize?.disconnect(); this.intersection?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
